import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import ExpiredAdList from 'components/ExpiredAd/List';

const ScreenExpiredAdList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <ExpiredAdList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};
export default ScreenExpiredAdList;
